import { TaxAndCompliance } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/TaxAndCompliance/TaxAndCompliance';

interface Props {
	organizationId: string;
}

export const ProgrammeDefaultsTaxAndCompliance = ({ organizationId }: Props) => (
	<TaxAndCompliance organizationId={organizationId} />
);
